import gsap from 'gsap';
import { EventDispatcher } from '../controllers/EventDispatcher.js';
import barba from '@barba/core';
import GlobalStore from '../datastorage/GlobalStore.js';
import { getApp } from '../main.js';

export default class MainNavigation {
    constructor() {
        this._arr_logoCorporate = document.querySelectorAll('#main-logo');

        this.holder_MainNavigation = document.getElementById('holder-main-navigation');
        this.arr_Buttons = Array.from(this.holder_MainNavigation.querySelectorAll('[data-btn-type="main-navigation"]'));
        this.holder_LogIn = document.getElementById('holder-main-navigation-login');

        this.holder_FooterNavigation = document.getElementById('wrapper-footer-navigation');
        this.arr_FooterButtons = this.holder_FooterNavigation.querySelectorAll('[data-btn-type="main-navigation-footer"]');

        this.arr_ButtonsPlattform = this.holder_LogIn.querySelectorAll('[data-btn-type="main-navigation-plattform"]');

        this.arr_Buttons.push(this.holder_LogIn.querySelector('#register'));

        this.btn_LogIn = document.getElementById('login-menue');
        this.holder_LogInFlyout = document.getElementById('login-flyout');
        this.is_LogInFlyoutOpen = false;

        this.btn_Burger = document.getElementById('burger-menu');
        this.top_Bar = document.getElementById('top-bar');

        this.is_MenueOpen = false;
        this.is_BurgerMenue = false;

        GlobalStore.set('isBurgerOpen', this.is_MenueOpen);

        this._onDocumentClickBound = this._onDocumentClick.bind(this);

        this.init();
    }

    init() {
        this.setupPageFlipListeners();
        this.buildNavigation();
        this.onWindowResize();
    }

    setupPageFlipListeners() {
        EventDispatcher.on('pageTransition', this.handlePageTransition.bind(this));
        EventDispatcher.on('pageResize', this.onWindowResize.bind(this), false);
    }

    buildNavigation() {
        this.arr_Buttons.forEach((button) => {
            button.addEventListener('click', this.onMainButtonClick.bind(this));
            if (GlobalStore.get('device') === 'desktop') {
                button.addEventListener('mouseover', this.onMainButtonOver.bind(this));
                button.addEventListener('mouseout', this.onMainButtonOut.bind(this));
            }
        });

        this._arr_logoCorporate.forEach((button) => {
            button.addEventListener('click', this.onMainButtonClick.bind(this));
        });

        this.arr_ButtonsPlattform.forEach((button) => {
            if (button.id === 'login-menue') {
                button.addEventListener('click', this.controllLogInFlyout.bind(this));
            } else if (button.id == 'login-user' || button.id == 'login-builder') {
                button.addEventListener('click', this.onPlattformButtonClick.bind(this));
                if (GlobalStore.get('device') === 'desktop') {
                    button.addEventListener('mouseover', this.onMainButtonOver.bind(this));
                    button.addEventListener('mouseout', this.onMainButtonOut.bind(this));
                }
            }
        });

        this.arr_FooterButtons.forEach((button) => {
            button.addEventListener('click', this.onMainButtonClick.bind(this));
            if (GlobalStore.get('device') === 'desktop') {
                button.addEventListener('mouseover', this.onFooterButtonOver.bind(this));
                button.addEventListener('mouseout', this.onFooterButtonOut.bind(this));
            }
        });

        this.btn_Burger.addEventListener('click', this.controllBurgerMenue.bind(this));
    }

    controllLogInFlyout(e) {
        gsap.killTweensOf(this.holder_LogInFlyout);

        if (this.is_LogInFlyoutOpen === false) {
            this.toggleLogInMenue('open');
            this.showLogInFlyOut();
            this.is_LogInFlyoutOpen = true;
            GlobalStore.set('isLogInFlyoutOpen', true);
            document.addEventListener('click', this._onDocumentClickBound);
        } else {
            this.toggleLogInMenue('close');
            this.hideLogInFlyOut();
            this.is_LogInFlyoutOpen = false;
            GlobalStore.set('isLogInFlyoutOpen', false);
            document.removeEventListener('click', this._onDocumentClickBound);
        }
    }

    _onDocumentClick(e) {
        if (e.target.id !== 'login-flyout' && e.target.id !== 'login-menue' && e.target.id !== 'login-user' && e.target.id !== 'login-builder') {
            this.toggleLogInMenue('close');
            this.hideLogInFlyOut();
            this.is_LogInFlyoutOpen = false;
            GlobalStore.set('isLogInFlyoutOpen', false);
            document.removeEventListener('click', this._onDocumentClickBound);
        }
    }

    showLogInFlyOut() {
        this.holder_LogInFlyout.style.display = 'flex';
        gsap.to(this.holder_LogInFlyout, {
            opacity: 1,
            duration: 0.35,
            ease: 'power2.out',
            onComplete: () => {
                this.holder_LogInFlyout.style.pointerEvents = 'auto';
            },
        });
    }

    hideLogInFlyOut() {
        gsap.to(this.holder_LogInFlyout, {
            opacity: 0,
            duration: 0.35,
            ease: 'power2.out',
            onStart: () => {
                this.holder_LogInFlyout.pointerEvents = 'auto';
            },
            onComplete: () => {
                this.holder_LogInFlyout.style.display = 'none';
            },
        });
    }

    toggleLogInMenue(state) {
        if (state === 'open') {
            gsap.killTweensOf(this.btn_LogIn);

            gsap.killTweensOf(this.btn_LogIn.querySelector('.main-navigation-item-title'));

            gsap.to(this.btn_LogIn, {
                backgroundColor: (i, el) => gsap.getProperty(el, '--col-bg-flyout'),
                duration: 0.65,
                ease: 'power2.out',
            });

            gsap.to(this.btn_LogIn.querySelector('.main-navigation-item-title'), {
                color: (i, el) => gsap.getProperty(el, '--col-bg-main-navigation-active'),
                duration: 0.65,
                ease: 'power2.out',
            });
        } else if (state === 'close') {
            gsap.killTweensOf(this.btn_LogIn);
            gsap.killTweensOf(this.btn_LogIn.querySelector('.main-navigation-item-title'));

            gsap.to(this.btn_LogIn, {
                backgroundColor: (i, el) => gsap.getProperty(el, '--col-bg-main-navigation-static'),
                duration: 0.65,
                ease: 'power2.out',
            });

            gsap.to(this.btn_LogIn.querySelector('.main-navigation-item-title'), {
                color: (i, el) => gsap.getProperty(el, '--col-font-main-black'),
                duration: 0.65,
                ease: 'power2.out',
            });
        }
    }

    controllBurgerMenue() {
        if (this.is_MenueOpen === false) {
            this.toggleBurgerMenue('open');
            this.showMainMenue();
            this.is_MenueOpen = true;
            GlobalStore.set('isBurgerOpen', true);
            getApp().myContentAnimationController.smoothScrollPaused(true);
        } else {
            if (this.is_LogInFlyoutOpen) this.controllLogInFlyout();
            this.toggleBurgerMenue('close');
            this.hideMainMenue();
            this.is_MenueOpen = false;
            GlobalStore.set('isBurgerOpen', false);
            getApp().myContentAnimationController.smoothScrollPaused(false);
        }
    }

    toggleBurgerMenue(state) {
        if (state === 'open') {
            gsap.killTweensOf(this.btn_Burger.querySelector('#icon-burger-menu-close'));
            gsap.to(this.btn_Burger.querySelector('#icon-burger-menu-close'), {
                opacity: 1,
                scale: 1,
                duration: 0.65,
                ease: 'power2.out',
            });
            gsap.killTweensOf(this.btn_Burger.querySelector('#icon-burger-menu-open'));
            gsap.to(this.btn_Burger.querySelector('#icon-burger-menu-open'), {
                opacity: 0,
                scale: 0,
                duration: 0.65,
                ease: 'power2.out',
            });
        } else if (state === 'close') {
            gsap.killTweensOf(this.btn_Burger.querySelector('#icon-burger-menu-open'));
            gsap.to(this.btn_Burger.querySelector('#icon-burger-menu-open'), {
                opacity: 1,
                scale: 1,
                duration: 0.65,
                ease: 'power2.out',
            });
            gsap.killTweensOf(this.btn_Burger.querySelector('#icon-burger-menu-close'));
            gsap.to(this.btn_Burger.querySelector('#icon-burger-menu-close'), {
                opacity: 0,
                scale: 0,
                duration: 0.65,
                ease: 'power2.out',
            });
        }
    }

    showMainMenue() {
        this.holder_MainNavigation.style.pointerEvents = 'none';

        gsap.killTweensOf(this.top_Bar);
        gsap.fromTo(
            this.top_Bar,
            { height: '50vh' },
            {
                height: '98dvh',
                minHeight: window.innerWidth >= 767 ? '35rem' : 'none',
                maxHeight: window.innerWidth >= 767 ? '35rem' : 'none',
                duration: 0.45,
                ease: 'power2.out',
                onComplete: () => {
                    this.holder_MainNavigation.style.pointerEvents = 'auto';
                },
            }
        );

        this.arr_Buttons.forEach((button, i) => {
            gsap.killTweensOf(button);
            gsap.set(button, { opacity: 0, pointerEvents: 'none', display: 'inline-block' });
            gsap.to(button, {
                opacity: 1,
                duration: 0.35,
                ease: 'power2.out',
                delay: 0.08 * i + 0.2,
                onComplete: () => {
                    if (button !== this.last_Button) button.style.pointerEvents = 'auto';
                },
            });
        });

        gsap.to(this.holder_LogIn, {
            opacity: 1,
            duration: 0.45,
            delay: 0.65,
            ease: 'power2.out',
        });

        this.arr_ButtonsPlattform.forEach((button) => {
            gsap.set(button, { pointerEvents: 'auto', display: 'inline-block', opacity: 1 });
        });
    }

    setMainMenueHide() {
        this.arr_Buttons.forEach((button) => {
            button.style.pointerEvents = 'none';
            button.style.opacity = 0;
            button.style.display = 'none';
        });
    }

    hideMainMenue() {
        gsap.killTweensOf(this.top_Bar);
        gsap.fromTo(
            this.top_Bar,
            { height: '10rem' },
            {
                height: '5.5rem',
                minHeight: 'unset',
                maxHeight: 'unset',
                duration: 0.45,
                ease: 'power2.out',
            }
        );

        this.arr_Buttons.forEach((button) => {
            gsap.killTweensOf(button);
        });
        this.setMainMenueHide();

        gsap.killTweensOf(this.holder_LogIn);
        gsap.to(this.holder_LogIn, {
            opacity: 0,
            duration: 0,
            ease: 'power2.out',
        });

        this.setPlattformLinksInactive();
    }

    resetBurgerMenue() {
        gsap.killTweensOf(this.top_Bar);
        gsap.set(this.top_Bar, { height: '5.5rem', minHeight: 'unset', maxHeight: 'unset' });

        this.arr_Buttons.forEach((button) => {
            gsap.killTweensOf(button);

            if (button !== this.last_Button) button.style.pointerEvents = 'auto';
            gsap.set(button, { opacity: 1, display: 'inline-block' });
        });

        gsap.killTweensOf(this.holder_LogIn);
        this.holder_LogIn.removeAttribute('style');

        this.toggleBurgerMenue('close');
        this.is_MenueOpen = false;
        GlobalStore.set('isBurgerOpen', false);

        getApp().myContentAnimationController.smoothScrollPaused(false);
    }

    onPlattformButtonClick(e) {
        const url = e.currentTarget.getAttribute('data-btn-url');
        this.controllLogInFlyout();
        if (this.is_BurgerMenue) this.controllBurgerMenue();
        barba.force(url);
    }

    openLogInOptions(e) {
        const url = e.target.value;
        e.target.selectedIndex = 0;

        barba.force(url);
    }

    onMainButtonClick(e) {
        const url = e.currentTarget.getAttribute('data-btn-url');
        barba.go(url);
    }

    onMainButtonOver(e) {
        this.animateOver(e.currentTarget);
    }

    onMainButtonOut(e) {
        if (e.currentTarget.style.pointerEvents !== 'none') {
            this.animateOut(e.currentTarget);
        }
    }

    onFooterButtonOver(e) {
        this.animateFooterOver(e.currentTarget);
    }

    onFooterButtonOut(e) {
        if (e.currentTarget.style.pointerEvents !== 'none') {
            this.animateFooterOut(e.currentTarget);
        }
    }

    animateFooterOver(elem) {
        gsap.killTweensOf(elem.querySelector('.main-navigation-item-title'));

        gsap.to(elem.querySelector('.main-navigation-item-title'), {
            color: (i, el) => gsap.getProperty(el, '--col-font-main-navigation-over'),
            duration: 0.45,
            ease: 'power2.out',
        });
    }

    animateFooterOut(elem) {
        gsap.killTweensOf(elem.querySelector('.main-navigation-item-title'));

        gsap.to(elem.querySelector('.main-navigation-item-title'), {
            color: (i, el) => gsap.getProperty(el, '--col-font-main-white'),
            duration: 0.65,
            ease: 'power2.out',
        });
    }

    animateOver(elem) {
        gsap.killTweensOf(elem.querySelector('.main-navigation-item-title'));

        gsap.to(elem.querySelector('.main-navigation-item-title'), {
            color: (i, el) => gsap.getProperty(el, '--col-font-main-navigation-over'),
            duration: 0.45,
            ease: 'power2.out',
        });
    }

    animateOut(elem) {
        gsap.killTweensOf(elem.querySelector('.main-navigation-item-title'));

        gsap.to(elem.querySelector('.main-navigation-item-title'), {
            color: (i, el) => gsap.getProperty(el, '--col-font-main-black'),
            duration: 0.65,
            ease: 'power2.out',
        });
    }

    animateActive(elem) {
        gsap.killTweensOf(elem);
        gsap.killTweensOf(elem.querySelector('.main-navigation-item-title'));

        gsap.to(elem, {
            backgroundColor: (i, el) => gsap.getProperty(el, '--col-bg-main-navigation-active'),
            duration: 0.65,
            ease: 'power2.out',
        });

        gsap.to(elem.querySelector('.main-navigation-item-title'), {
            color: (i, el) => gsap.getProperty(el, '--col-font-main-white'),
            duration: 0.65,
            ease: 'power2.out',
        });
    }

    animateInActive(elem) {
        gsap.killTweensOf(elem);
        gsap.killTweensOf(elem.querySelector('.main-navigation-item-title'));

        gsap.to(elem, {
            backgroundColor: (i, el) => gsap.getProperty(el, '--col-bg-main-navigation-static'),
            duration: 0.65,
            ease: 'power2.out',
        });

        gsap.to(elem.querySelector('.main-navigation-item-title'), {
            color: (i, el) => gsap.getProperty(el, '--col-font-main-black'),
            duration: 0.65,
            ease: 'power2.out',
        });
    }

    setActive(btn) {
        if (this.last_Button) {
            this.setInActive(this.last_Button);
        }

        if (btn) {
            this.last_Button = btn;
            this.last_Button.style.pointerEvents = 'none';
            this.animateActive(this.last_Button);
        }
    }

    setInActive(btn) {
        btn.style.pointerEvents = 'auto';
        this.animateInActive(btn);
    }

    setPlattformLinksInactive() {
        this.arr_ButtonsPlattform.forEach((button) => {
            gsap.set(button, { pointerEvents: 'none' });
        });
    }

    setPlattformLinksActive() {
        this.arr_ButtonsPlattform.forEach((button) => {
            gsap.set(button, { pointerEvents: 'auto' });
        });
    }

    setMainButtonsInactive() {
        this.arr_Buttons.forEach((button) => {
            gsap.set(button, { pointerEvents: 'none' });
        });
    }

    setMainButtonsActive() {
        this.arr_Buttons.forEach((button) => {
            gsap.set(button, { pointerEvents: 'auto' });
        });
    }

    handlePageTransition(data) {
        if (data.detail.namespace === 'leave' || data.detail.namespace === 'once') {
            const cleanUrl = barba.history.current.url.split('#')[0];

            let currentBtn;

            if (this.holder_MainNavigation.querySelector('[data-btn-url="' + cleanUrl + '"]')) {
                currentBtn = this.holder_MainNavigation.querySelector('[data-btn-url="' + cleanUrl + '"]');
            } else if (!this.holder_MainNavigation.querySelector('[data-btn-url="' + cleanUrl + '"]')) {
                currentBtn = this.holder_LogIn.querySelector('[data-btn-url="' + cleanUrl + '"]');
            }

            this.setActive(currentBtn);

            if (this.is_MenueOpen) {
                if (this._dcCloseBurger) {
                    this._dcCloseBurger.kill();
                    this._dcCloseBurger = null;
                }
                this.setPlattformLinksInactive();
                this.setMainButtonsInactive();
                this._dcCloseBurger = gsap.delayedCall(0.45, this.controllBurgerMenue.bind(this));
            }
        }
    }

    onWindowResize(e) {
        let ww = window.innerWidth;
        if (ww > 1480 && this.is_BurgerMenue === true) {
            if (this.is_LogInFlyoutOpen) this.controllLogInFlyout();
            this.resetBurgerMenue();
            this.setPlattformLinksActive();
            this.is_BurgerMenue = false;
        } else if (ww <= 1480 && this.is_BurgerMenue === false) {
            if (this.is_LogInFlyoutOpen) this.controllLogInFlyout();
            this.setPlattformLinksInactive();
            this.setMainMenueHide();
            this.is_BurgerMenue = true;
        }
    }
}
